import React from 'react';
import { Carousel } from "react-bootstrap";

function Carousels() {
    return (     
        <Carousel interval={1000}>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://images-eu.ssl-images-amazon.com/images/G/31/prime/Gateway/2020/May/gaming_1500x600._CB431281464_.jpg"
                    alt="First slide"
                />           
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://images-eu.ssl-images-amazon.com/images/G/31/img20/Wireless/SamsungM/M51/26th_GWM51/Rv1/P38983965_IN_WLME_SamsungGalaxy_M51_Design_Change_1500x600_1._CB416037929_.jpg"
                    alt="Third slide"
                />
            </Carousel.Item>
            <Carousel.Item>
                <img
                    className="d-block w-100"
                    src="https://images-eu.ssl-images-amazon.com/images/G/31/img19/AmazonPay/Rajeshwari/Oct/GW/DesktopHero_1500x600._CB402740210_.jpg"
                    alt="Third slide"
                />
            </Carousel.Item>
        </Carousel>
    );
}

export default Carousels